export default "/images/accept.svg?e069016662eb737de51cdebede994c50";